// Client layer (TS-2.5.03). A risk-bucket note's TYPE ("Risk", "Blocker", or whatever an
// admin-added type resolved to) rendered as a non-color-only signal - the same house pattern
// `SeverityBadge.tsx` (features/dataQuality) already established for D-227: the label text itself
// is the accessible cue, never an icon or a colour alone. `RiskItem.severityColorHex`, when
// present, tints the badge as an ACCENT on top of that text signal using D-247's own
// computed-ink chip mechanism (`--eg-chip-color`/`--eg-chip-ink`) - never as the only cue. A note
// whose severity resolved to nothing (`severityColorHex === null`, BRD's own "unassessed" state,
// D-012) renders the same badge in its neutral, uncoloured form rather than fabricating a colour.
import type { CSSProperties } from "react";
import { resolveColor } from "./lib/colorTokens";
import { readableTextColor } from "./lib/contrast";
import type { RiskItem } from "../../api/generated/contracts";

export interface RiskTypeBadgeProps {
  readonly note: Pick<RiskItem, "typeLabel" | "severityColorHex">;
}

export function RiskTypeBadge({ note }: RiskTypeBadgeProps) {
  const style = note.severityColorHex
    ? ({
        "--eg-chip-color": resolveColor(note.severityColorHex),
        "--eg-chip-ink": readableTextColor(note.severityColorHex),
      } as CSSProperties)
    : undefined;

  return (
    <span className="eg-risk-badge" style={style}>
      {note.typeLabel}
    </span>
  );
}
